/* eslint-disable max-statements */
/* eslint-disable yoda */
import PropTypes from "prop-types";
import { ReCaptchaV2 } from "react-recaptcha-x";
import { useCallback } from "react";
import { useMutation } from "react-query";

import LwcErrorBoundary from "../LwcErrorBoundary";
import { useNotifications } from "../NotificationsContext";
import { verifyRecaptchaMutation } from "./RecaptchaMutation";

const RecaptchaField = ({
	className,
	onFail,
	onSuccess
}) => {
	const { addNotification } = useNotifications();

	const {
		mutateAsync: verify
	} = verifyRecaptchaMutation(useMutation);

	const recaptchaCallback = useCallback(async (token) => {
		if (false === token) {
			if (onFail) {
				onFail("");
			}
			return;
		}

		try {
			const result = await verify(token.toString());

			if (result.success) {
				if (onSuccess) {
					onSuccess("human");
				}
			} else {
				throw new Error("Could not verify your humanity.");
			}
		} catch (error) {
			addNotification({
				message: `${error.message || "Could not verify your humanity."} Please reload the page and try again.`,
				type: "danger"
			});
		}
	}, []);

	return (
		<LwcErrorBoundary>
			<ReCaptchaV2 callback={recaptchaCallback} className={className} />
		</LwcErrorBoundary>
	);
};

RecaptchaField.propTypes = {
	className: PropTypes.string,
	onFail: PropTypes.func,
	onSuccess: PropTypes.func.isRequired
};

RecaptchaField.defaultProps = {
	className: "",
	onFail: null
};

export default RecaptchaField;
